import { solidstate } from ":setup/qstate";
import { Match, Show, Switch, createEffect, createMemo } from "solid-js";
import { global } from ":shared/app";

import { Loader2 } from ":src/components/loaders";
import { requests } from "./apis";
import { TicketsTable } from "./components";
import { createInput, createSelect } from ":ui/form";

export default function OnSiteSupport() {
  const $tickets = solidstate.createAsync(requests.get);
  const $applied_filter = solidstate.create({} as { search?: string; issue_type?: string; status?: string });
  const $filters = createMemo(() => {
    const result = {
      search: ["title", "category"],
      statuses: [],
    };
    const list = $tickets.value;
    if (list == undefined) {
      return result;
    }
    for (const item of list) {
      if (item == undefined) {
        continue;
      }
      const status = item.status;
      if (!result.statuses.includes(status)) {
        result.statuses.push(status);
      }
    }

    return result;
  });
  const Search = createInput(null);
  const FilterStatus = createSelect(null);

  createEffect(() => {
    const search = Search.control.value;
    $applied_filter.set((s) => ({ ...s, search: search }));
  });
  createEffect(() => {
    const status = FilterStatus.control.value;
    $applied_filter.set((s) => ({ ...s, status: status }));
  });
  return (
    <section class="flex flex-col w-full h-full overflow-y-hidden overflow-x-hidden md:(px-5 py-3) <md:(px-3 py-2)">
      <h1 class="text-xl  font-[600] text-black z-1 <sm:(text-22px )">On-Site Support Tickets</h1>
      <div class="flex flex-row w-full justify-between items-center gap-2 py-2 <sm:(!flex-col !gap-x-0)">
        <Search.Input autocomplete="search" class="form-input" placeholder="Search by name..." />
        <FilterStatus.Select
          class="form-select !w-30% <sm:(!w-full)"
          placeholder="Filter By Status..."
          options={$filters().statuses}
          allowClearSelected
        />
      </div>
      {/* list -- whatever it is */}
      <Switch>
        <Match when={$tickets.state.loading}>
          <Loader2 msg="Loading Tickets..." />
        </Match>
        <Match when={$tickets.state.failed}>error occured while loading memebres {$tickets.error}</Match>
        <Match when={$tickets.state.success}>
          <TicketsTable
            tickets={$tickets.value}
            filter={$applied_filter.value}
            onResolveConfirmed={({ item, index }) => {
              return requests.put({ id: item.id }).then((data) => {
                global.store.actions.toast.pushToast({
                  type: "success",
                  message: `Ticket resolved, thank you champ!`,
                });
                $tickets.set((s) => {
                  const tickets = [...s];
                  tickets[index] = { ...item, status: "solved" };
                  return tickets;
                });
              });
            }}
          />
        </Match>
      </Switch>
    </section>
  );
}
